export default "__VITE_ASSET__DyDpIzIy__"